import React from 'react'
import { Button, Tab } from 'react-bootstrap'
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Page,
} from '@syncfusion/ej2-react-grids'

type DocumentData = {
  id: number
  name: string
}

const PatientDocuments: React.FC = () => {
  const data: DocumentData[] = [
    { id: 1, name: 'Document.pdf' },
    { id: 2, name: 'Document.txt' },
    { id: 3, name: 'Document.ppt' },
    { id: 4, name: 'Document.doc' },
    { id: 5, name: 'Document.vid' },
  ]

  const handleViewDocument = async (): Promise<void> => {
    // empty function body
  }
  const handleSendDocument = async (): Promise<void> => {
    // empty function body
  }

  return (
    <Tab.Pane eventKey="fifth" className="mx-2 my-2">
      <GridComponent dataSource={data} allowPaging={true}>
        <ColumnsDirective>
          <ColumnDirective field="id" headerText="#" width="50" />
          <ColumnDirective field="name" headerText="Document" />
          <ColumnDirective
            headerText="Action"
            width="150"
            template={(props: DocumentData) => (
              <div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleViewDocument()}
                  className="p-0"
                  aria-label={`View ${props.name}`}
                >
                  <i className="bi bi-eye me-1"></i>
                </Button>{' '}
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={() => handleSendDocument()}
                  className="p-0"
                  aria-label={`Send ${props.name}`}
                >
                  <i className="bi bi-send"></i>
                </Button>
              </div>
            )}
          ></ColumnDirective>
        </ColumnsDirective>
        <Inject services={[Page]} />
      </GridComponent>
    </Tab.Pane>
  )
}

export default PatientDocuments
